module.exports = __webpack_public_path__ + "static/vf-button-wallet.330577f6.svg";